<template>
	<div class="form-group m-b-0">
		<label :for="filterName" data-testid="singleSelectLabel">{{ placeholder }}</label>
		<select :id="filterName" data-testid="singleSelectFilterBtn" :disabled="isDisabled()" class="c-select" v-model="selectedItem" @change="handleStateChanged">
			<option
				v-for="(item, idx) in filteredChoices"
				:value="{ name: item.name, nameChiclet: item.nameChiclet || item.name, value: item.value }"
				:disabled="!item.enabled"
				:key="idx">
				{{ item.name }}
			</option>
		</select>
		<span class="label-help ng-scope" v-if="!isValid && required">{{ required }}</span>
	</div>
</template>

<script>
import { defineComponent } from 'vue';
export default defineComponent({
	name: 'SingleSelect',
	props: {
		choices: {
			type: Array,
			default: () => []
		},
		filterName: {
			type: String,
			required: true
		},
		required: {
			type: String,
			default: null
		},
		placeholder: {
			type: String,
			required: true
		},
		externalData: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			selectedItem: null,
			selectVisible: false,
			isValid: true,
			items: [],
			forceDisabled: false
		};
	},
	computed: {
		filteredChoices() {
			return this.items.filter(item => {
				return item.visible;
			});
		}
	},
	mounted() {
		this.items = this.choices;
		this.setSelectedValue();
	},
	methods: {
		getSelectedValue() {
			return this.selectedItem ? this.selectedItem.value : null;
		},
		getSelectedObject() {
			return this.selectedItem;
		},
		setChoices(choices, setValue) {
			this.items = choices;
			if (setValue) this.setSelectedValue();
		},

		handleStateChanged() {
			this.isValid = this.selectedItem !== null && this.selectedItem.value;
			this.$emit('change', this.selectedItem, this.externalData);
		},

		setSelectedValue() {
			for (const choice of this.choices) {
				if (choice.selected) {
					this.selectedItem = {
						name: choice.name,
						nameChiclet: choice.nameChiclet || choice.name,
						value: choice.value
					};
					return;
				}
			}
		},
		setSelected(value, triggerUpdate) {
			for (const choice of this.choices) {
				if (choice.value === value) {
					this.selectedItem = {
						name: choice.name,
						nameChiclet: choice.nameChiclet || choice.name,
						value: choice.value
					};
					break;
				}
			}
			if (triggerUpdate) this.handleStateChanged();
		},
		setEnabledDisabledIndex(idx, enabled) {
			if (idx >= this.items.length) return;
			this.items[idx].enabled = enabled;
		},
		setUnselected() {
			if (!this.selectedItem) return;
			this.selectedItem = null; // Note: This will "unselect" the select, but the first option may still appear checked in the select if there isn't a null option
			this.handleStateChanged();
		},
		isDisabled() {
			return this.forceDisabled || this.items.length === 0;
		},
		setForceDisabled(value) {
			this.forceDisabled = value;
		}
	}
});
</script>
